var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterestRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8525 9.35461L12.8518 9.3553L12.8518 9.35531L12.8514 9.35567L12.8222 9.38494L12.7857 9.41031C12.5604 9.56725 12.2561 9.92269 11.9617 10.3675C11.8471 10.5406 11.741 10.7166 11.6479 10.8846H36.3571C36.8089 10.8846 37.2439 11.0607 37.5661 11.3771C37.8886 11.6937 38.0714 12.1251 38.0714 12.5769C38.0714 13.0287 37.8886 13.4601 37.5661 13.7768C37.2439 14.0931 36.8089 14.2692 36.3571 14.2692H10.6429C9.8064 14.2692 9.006 14.5956 8.41728 15.1737C7.82886 15.7514 7.5 16.5331 7.5 17.3462V20.6154H14.2857C15.7036 20.6154 17.0652 21.1684 18.0705 22.1555C19.0762 23.1429 19.6429 24.4841 19.6429 25.8846C19.6429 27.2851 19.0762 28.6263 18.0705 29.6137C17.0652 30.6009 15.7036 31.1538 14.2857 31.1538H7.5V35.4231C7.5 36.2362 7.82886 37.0178 8.41728 37.5956C9.006 38.1736 9.8064 38.5 10.6429 38.5H37.3571C38.1936 38.5 38.994 38.1736 39.5827 37.5956C40.1711 37.0178 40.5 36.2362 40.5 35.4231V11.5769C40.5 10.7638 40.1711 9.98219 39.5827 9.40442C38.994 8.82635 38.1936 8.5 37.3571 8.5H15.2857C14.489 8.5 13.8722 8.72261 13.4568 8.9421C13.2487 9.05203 13.0917 9.16092 12.9894 9.23979C12.9383 9.27917 12.9011 9.31084 12.8782 9.33111C12.8668 9.34124 12.859 9.34848 12.8549 9.35239L12.8525 9.35461ZM15.6527 27.214C16.0134 26.8599 16.2143 26.3815 16.2143 25.8846C16.2143 25.3878 16.0134 24.9094 15.6527 24.5552C15.2917 24.2007 14.8001 24 14.2857 24H7.5V27.7692H14.2857C14.8001 27.7692 15.2917 27.5685 15.6527 27.214Z",
    fill: "url(#paint0_linear_24786_52038)",
    stroke: "url(#paint1_radial_24786_52038)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint2_linear_24786_52038)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint3_radial_24786_52038)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24786_52038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4118 33.7059C38.4118 35.7526 36.7526 37.4118 34.7059 37.4118C32.6592 37.4118 31 35.7526 31 33.7059C31 31.6592 32.6592 30 34.7059 30C36.7526 30 38.4118 31.6592 38.4118 33.7059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 44.2941C49 46.3408 47.3408 48 45.2941 48C43.2474 48 41.5882 46.3408 41.5882 44.2941C41.5882 42.2474 43.2474 40.5882 45.2941 40.5882C47.3408 40.5882 49 42.2474 49 44.2941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3798 31.0588C48.7933 31.4723 48.7933 32.1427 48.3798 32.5562L33.5562 47.3798C33.1427 47.7933 32.4723 47.7933 32.0588 47.3798C31.6453 46.9663 31.6453 46.2959 32.0588 45.8824L46.8824 31.0588C47.2959 30.6453 47.9663 30.6453 48.3798 31.0588Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52038",
    x: 16,
    y: 15,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52038"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52038",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24786_52038",
    x: 31,
    y: 30,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24786_52038"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24786_52038",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52038",
    x1: 41,
    y1: 8,
    x2: 26.3742,
    y2: 40.0824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA300"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52038",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1538 -6.90385) rotate(126.968) scale(38.0539 39.1904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24786_52038",
    x1: 24,
    y1: 23,
    x2: 40,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52038",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 23) scale(32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestRates);
export default __webpack_public_path__ + "static/media/interestRates.93e6449613995305dd595d1ffdee84b1.svg";
export { ForwardRef as ReactComponent };